<script setup>
import { ref, computed } from 'vue';
import {
  LINE_STICKER_PACKAGES,
  lineStickerImageUrl,
} from 'shared/constants/lineStickers';

const emit = defineEmits(['select']);

const selectedPackageId = ref(LINE_STICKER_PACKAGES[0].packageId);

const selectedPackage = computed(() =>
  LINE_STICKER_PACKAGES.find(
    ({ packageId }) => packageId === selectedPackageId.value
  )
);

// Each package is shown by its first sticker, so the tab strip needs no package names.
const onSelect = stickerId =>
  emit('select', { packageId: selectedPackageId.value, stickerId });
</script>

<template>
  <div
    class="absolute bottom-16 left-3 z-10 w-80 rounded-lg border border-n-weak bg-n-alpha-3 backdrop-blur-[100px] shadow-lg"
  >
    <div class="flex gap-1 overflow-x-auto border-b border-n-weak p-2">
      <button
        v-for="{ packageId, stickerIds } in LINE_STICKER_PACKAGES"
        :key="packageId"
        type="button"
        class="size-8 shrink-0 rounded p-0.5 hover:bg-n-alpha-2"
        :class="{ 'bg-n-alpha-2': packageId === selectedPackageId }"
        @click="selectedPackageId = packageId"
      >
        <img
          :src="lineStickerImageUrl(stickerIds[0])"
          :alt="packageId"
          class="size-full object-contain"
          loading="lazy"
        />
      </button>
    </div>
    <div class="flex flex-wrap gap-2 p-3 max-h-64 overflow-y-auto">
      <button
        v-for="stickerId in selectedPackage.stickerIds"
        :key="stickerId"
        type="button"
        class="size-12 rounded p-1 hover:bg-n-alpha-2"
        @click="onSelect(stickerId)"
      >
        <img
          :src="lineStickerImageUrl(stickerId)"
          :alt="String(stickerId)"
          class="size-full object-contain"
          loading="lazy"
        />
      </button>
    </div>
  </div>
</template>
